import { Link, useSearch } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';

import { AuthCard } from './AuthCard';
import { useSubmit } from './useSubmit';
import { auth } from '../../api/endpoints';
import { Button } from '../../components/Button';
import { ErrorBanner } from '../../components/ErrorBanner';
import { Field } from '../../components/Field';
import { useT } from '../../i18n/provider';

export function ResetPasswordScreen() {
  const t = useT();
  const search = useSearch({ strict: false }) as { token?: string };
  const { busy, error, fields, submit } = useSubmit<void>();
  const [done, setDone] = useState(false);

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const password = String(new FormData(event.currentTarget).get('password') ?? '');

    void submit(() => auth.resetPassword({ token: search.token ?? '', password }), () => setDone(true));
  };

  if (done) {
    return (
      <AuthCard title={t('auth.reset.doneTitle')} subtitle={t('auth.reset.doneSubtitle')}>
        <Link to="/login" className="text-sm font-semibold text-primary">
          {t('auth.signIn')}
        </Link>
      </AuthCard>
    );
  }

  return (
    <AuthCard title={t('auth.reset.chooseTitle')}>
      <form onSubmit={onSubmit} className="space-y-4">
        {error ? <ErrorBanner error={error} /> : null}
        <Field
          label={t('auth.newPassword')}
          name="password"
          type="password"
          autoComplete="new-password"
          required
          minLength={12}
          hint={t('auth.reset.passwordHint')}
          error={fields.password}
        />
        <Button type="submit" busy={busy} size="lg" block>
          {t('auth.reset.change')}
        </Button>
      </form>
    </AuthCard>
  );
}
